module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("big_preloader", [["div",{"class":"preloader-block"},[["div",{"class":"big-preload"},[["div",{"class":"loader-37"}],["div",{"class":"loadtext text-color-4"},[["textNode",{"text":"Loading"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/preloaders.tpl
// module id = 1060
// module chunks = 4